export const enabled = value => value === true || value === 1 || value === '1';
export function playSource(model) {
  const button = model.play_button || {};
  if (Number(button.type) === 3) return button.custom_source || '';
  if (Number(button.type) === 2 && /^playbutton([1-9]|1[0-9]|2[0-9])\.png$/.test(button.library_source || '')) {
    return require(`../../../../assets/images/icons/play-buttons/${button.library_source}`);
  }
  return '';
}
export function soundSource(model) {
  const settings = model.settings || {};
  const autoplay = settings.autoplay_settings || {};
  if (Number(autoplay.type) === 2) return autoplay.custom_image || '';
  const name = settings.unmute_image || 'ClickForSound_1.png';
  if (/^ClickForSound_([1-9]|[1-3][0-9]|40)\.png$/.test(name)) {
    return require(`../../../../assets/images/videos/unmute-video/${name}`);
  }
  return '';
}
export const soundSize = value => ({ 1: 32, 2: 48, 3: 72, 4: 96 }[value] || 96);
export const playSize = value => ({ 1: 72, 2: 96, 3: 120, 4: 144 }[value] || 96);
export function animationClass(value) {
  if (!value || value === 'none') return '';
  return `animate__animated animate__infinite animate__slower animate__${value === 'heartbeat' ? 'heartBeat' : value}`;
}
